import React, { FC } from 'react';
import './sortableHeader.scss';

interface SortableHeaderProps {
    title: string;
    field: string;
    currentSortField: string;
    currentSortDirection: 'asc' | 'desc';
    onSort: (field: string) => void;
}

const SortableHeader: FC<SortableHeaderProps> = ({
    title,
    field,
    currentSortField,
    currentSortDirection,
    onSort,
}) => (
    <div
        role="button"
        tabIndex={0}
        onClick={() => onSort(field)}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSort(field); } }}
        style={{ cursor: 'pointer', userSelect: 'none' }}
        className="sortable-header">
        {title}
        <span className="sort-indicator">
            {currentSortField === field && (
                currentSortDirection === 'asc' ? ' ↑' : ' ↓'
            )}
        </span>
    </div>
);

export default SortableHeader;
